/**
 * Shared simulation types.
 *
 * Ported from the 2013 C enums:
 *   - `Direction`    <- Moto.h  (NON_DIRIGE / HAUT / BAS / GAUCHE / DROITE)
 *   - `PlayerState`  <- Joueur.h (MORT / VIVANT / MOURANT / DOUTE)
 *   - `BonusKind`    <- EffetBonus.h (AUCUN / NETTOYAGE / BOOST / SAUT)
 *   - `PlayerColor`  <- Couleur.h
 */

export const Direction = {
  None: 0,
  Up: 1,
  Down: 2,
  Left: 3,
  Right: 4,
} as const;
export type Direction = (typeof Direction)[keyof typeof Direction];

export const PlayerState = {
  Dead: 0,
  Alive: 1,
  Dying: 2,
  Doubt: 3,
} as const;
export type PlayerState = (typeof PlayerState)[keyof typeof PlayerState];

export const BonusKind = {
  None: 0,
  Clean: 1,
  Boost: 2,
  Jump: 3,
} as const;
export type BonusKind = (typeof BonusKind)[keyof typeof BonusKind];

export type PlayerColor =
  | "orange"
  | "blue"
  | "red"
  | "green"
  | "purple"
  | "darkblue"
  | "yellow"
  | "white";

/** Colour assignment order, matching the 2013 README.txt. */
export const PLAYER_COLORS: readonly PlayerColor[] = [
  "orange",
  "blue",
  "red",
  "green",
  "purple",
  "darkblue",
  "yellow",
  "white",
];

/** Neon rendering: [stroke, glow]. */
export const COLOR_HEX: Record<PlayerColor, readonly [string, string]> = {
  orange: ["#ffcc33", "#ff8800"],
  blue: ["#33ccff", "#0088ff"],
  red: ["#e82105", "#ff3b1f"],
  green: ["#21c621", "#5bff5b"],
  purple: ["#cc33ff", "#a11fff"],
  darkblue: ["#4c63ff", "#0d18b3"],
  yellow: ["#e7ef0b", "#fff75b"],
  white: ["#ffffff", "#bfe8ff"],
};

/** Axis-aligned bounding box: [x0, y0, x1, y1]. */
export type AABB = readonly [number, number, number, number];

/** A turn request handed to the simulation for the current tick. */
export type TurnInput =
  | typeof Direction.Up
  | typeof Direction.Down
  | typeof Direction.Left
  | typeof Direction.Right;
